<form [formGroup]="filterForm" (ngSubmit)="onSubmit()">
  <ap-label [status]="'DEFAULT'">{{ 'FILTERS.ADD.' + filter.getSipsFilterTemplate().criterion | translate }}</ap-label>
  <button class="btn btn-success" type="button" (click)="confirmSearch()" attr.aria-label="{{ 'FILTERS.ADD.VALID' | translate }}">
    {{ 'COMMON.LABELS.SEARCH.SEARCH_CB' | translate }}
  </button>
</form>

